import React from 'react';
import { Users } from 'lucide-react';
import ReferralInterestForm from '@/components/ReferralInterestForm';
import Seo from '@/components/Seo';
import Reveal from '@/components/Reveal';
import PageHero from '@/components/PageHero';

const AUDIENCE = [
  'Families', 'Guardians', 'Support Coordinators', 'CSBs', 'Case Managers',
  'Hospitals', 'Social Workers', 'Human Rights Advocates', 'Community Partners', 'Potential Residents'
];

const Placement = () => {
  return (
    <div className="relative z-10 min-h-screen">
      <Seo title="Referral Interest & Future Placement" description="Express interest in future placement at Forever Path Living™, a Virginia DBHDS supervised living organization. For families, guardians, support coordinators, CSBs, case managers, and community partners. Submission does not guarantee admission or placement." />
      <PageHero
        eyebrow="Building Relationships Before Opening Our Doors"
        title="Referral Interest & Future Placement"
        subtitle="A warm, professional way to express interest in future placement — not a guaranteed waitlist or admission list."
      />

      <section className="py-16 md:py-24 px-6 bg-cream-100">
        <div className="max-w-5xl mx-auto">
          <Reveal className="bg-cream-200 rounded-3xl p-8 md:p-12 border border-sage-200 mb-10">
            <p className="text-forest-700 text-lg leading-relaxed">
              Thank you for your interest in Forever Path Living™. We understand choosing a home is one of the most
              important decisions a family or support team can make. Completing this form lets us learn about the
              individual and begin determining whether Forever Path Living™ may be an appropriate future match.
              Submission of this form does not guarantee admission, placement, or availability.
            </p>
          </Reveal>

          <Reveal className="mb-12">
            <div className="flex items-center gap-3 mb-4">
              <div className="p-2.5 rounded-xl bg-sage-100 text-forest-700"><Users className="w-5 h-5" /></div>
              <h2 className="font-serif text-xl text-forest-800">Who this is for</h2>
            </div>
            <div className="flex flex-wrap gap-2">
              {AUDIENCE.map((a) => (
                <span key={a} className="px-3.5 py-1.5 rounded-full text-sm bg-cream-200 text-forest-700 border border-sage-200">{a}</span>
              ))}
            </div>
          </Reveal>

          <Reveal>
            <ReferralInterestForm />
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default Placement;
